import React, {Fragment, Suspense, lazy} from 'react';
import {Route, Switch} from 'react-router-dom';
import DashboardLayout from './layouts/DashoboardLayout';
import AuthGuard from "./components/AuthGuard";
import SlashScreen from "./components/LoadingScreen";
import ErrorBoundary from "./ErrorBoundary";

// Import route groups
import authRoutes from './routes/authRoutes';
import assetRoutes from './routes/assetRoutes';
import orderRoutes from './routes/orderRoutes';
import placeOrderRoutes from './routes/placeOrderRoutes';
import profileRoutes from './routes/profileRoutes';
import paymentRoutes from './routes/paymentRoutes';
import rfidRoutes from './routes/rfidRoutes';
import miscRoutes from './routes/miscRoutes';
import analyticsRoutes from './routes/analyticsRoutes';

const PublicGraph = lazy(() => import('./views/PublicGraph/PublicGraph'));

export const renderRoutes = (routes = []) => (
    <Suspense fallback={<SlashScreen/>}>
        <Switch>
            {routes.map((route, i) => {
                const Guard = route.guard || Fragment;
                const Layout = route.layout || Fragment;
                const Component = route.component;

                return (
                    <Route
                        key={i}
                        path={route.path}
                        exact={route.exact}
                        render={(props) => (
                            <Guard>
                                <ErrorBoundary fill={true}>
                                    <Layout>
                                        {route.routes ? (
                                            renderRoutes(route.routes)
                                        ) : (
                                            <Component {...props} />
                                        )}
                                    </Layout>
                                </ErrorBoundary>
                            </Guard>
                        )}
                    />
                );
            })}
        </Switch>
    </Suspense>
);

// Combine all routes
const routes = [
    ...authRoutes,
    {
        exact: true,
        path: '/public-graph',
        component: PublicGraph
    },
    {
        path: '/',
        guard: AuthGuard,
        layout: DashboardLayout,
        routes: [
            ...assetRoutes,
            ...orderRoutes,
            ...placeOrderRoutes,
            ...profileRoutes,
            ...paymentRoutes,
            ...rfidRoutes,
            ...analyticsRoutes,
            ...miscRoutes
        ]
    }
];

export default routes;
